import { Box } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { type FC } from "react";
import {
  planConversionBannerAlt,
  planConversionBannerImage,
  planConversionBannerImageHeight,
  planConversionBannerImageWidth,
  planConversionBannerTestId,
} from "./const";

export interface PlanConversionBannerProps {
  readonly href: string;
}

/**
 * 年間コース訴求バナー
 * マイページ最上部に置く画像バナー。InviteTopBanner と同じ「画像全体をLinkで囲む」方式。
 * 遷移先は自サイト内のLPのため target="_blank" は付けない。
 */
export const PlanConversionBanner: FC<PlanConversionBannerProps> = ({ href }) => {
  return (
    <Box
      as={Link}
      href={href}
      display="block"
      borderRadius="0.5rem"
      overflow="hidden"
      data-testid={planConversionBannerTestId}
    >
      <Image
        src={planConversionBannerImage}
        alt={planConversionBannerAlt}
        width={planConversionBannerImageWidth}
        height={planConversionBannerImageHeight}
        style={{ width: "100%", height: "auto" }}
      />
    </Box>
  );
};
